<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Reposição' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <ng-container>
    <div class="top">
      <div style="display: flex" class="ion-margin-bottom">
        <ion-searchbar
          class="searchbar"
          show-cancel-button="never"
          placeholder="{{'Buscar Inscrito' | translate}}"
          [(ngModel)]="filtroInscritos.q"
          (ionInput)="onInputInscritos()"
        >
        </ion-searchbar>

        <div class="qr-code">
          <i (click)="leitor()" class="fas fa-qrcode icon-qr"></i>
        </div>
      </div>

      <div *ngIf="inscritosList.length">
        <ion-list>
          <div *ngFor="let participante of inscritosList let i = index">
            <ion-item-sliding #slidingItem>
              <ion-item #item id="item{{i}}" (click)="openOption(slidingItem, item, participante)">
                <ion-avatar slot="start" class="avatar-cicle">
                  <img [src]="participante.foto | image:' '" />
                </ion-avatar>

                <ion-label>
                  <i *ngIf="participante.hasServico == '1'" class="fa-business-time fas description-icon"></i>

                  <p class="bold one-line">{{participante.nome}}</p>

                  <p class="text-format">
                    {{'Entrada' | translate}}:
                    <span color="medium">
                      {{ participante.data_check_in ? (participante.data_check_in | dateFormat:'dataHora') :
                      ('Não Informado' | translate) }}
                    </span>
                  </p>

                  <p class="text-format">
                    {{'Saida' | translate}}:
                    <span color="medium">
                      {{ participante.data_check_out ? (participante.data_check_out | dateFormat:'dataHora') :
                      ('Não Informado' | translate) }}
                    </span>
                  </p>
                </ion-label>

                <ion-note
                  slot="end"
                  (click)="changeCheck(participante)"
                  style="display: flex; align-items: center; font-size: 26px; right: 8px"
                >
                  <i *ngIf="participante.presenca != '1'" class="fal fa-circle"></i>

                  <i *ngIf="participante.presenca == '1'" class="fas fa-check" style="color: #1dbb00"></i>
                </ion-note>
              </ion-item>

              <ion-item-options *ngIf="participante.hasAtividade == '1'" side="end">
                <ion-button (click)="notas(participante)"> {{'Dar Notas' | translate}} </ion-button>
              </ion-item-options>
            </ion-item-sliding>
          </div>
        </ion-list>
      </div>

      <sem-registro *ngIf="!inscritosList.length"></sem-registro>

      <ion-infinite-scroll (ionInfinite)="loadInscritos($event)" *ngIf="pagination.currentPage < pagination.pageCount">
        <ion-infinite-scroll-content loadingText="{{'Carregando' | translate}}..."> </ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </div>

    <ion-row class="ion-margin-top">
      <ion-col size="12">
        <ion-button expand="block" class="btn-default" (click)="addReposicao()">
          {{'Adicionar Pessoa' | translate}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ng-container>
</ion-content>
